import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {
  const token = localStorage.getItem("access");
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const role = user?.role;

  // ❌ не залогинен
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // ❌ нет роли или не подходит
  if (roles && !roles.includes(role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
